export enum ReportStatus {
    Ongoing = 1,
    Completed = 2,
    Canceled = 3
}
